import { Input } from "./../../../Components/ui/input";
import React, { useState, useEffect } from "react";
import { ChevronDownIcon, ChevronUpIcon, X } from "lucide-react";
import { useAuth, useSettings } from "./../../../hooks";
import { getSession } from "./../../../axios.config";
import Loader from "./../../../Components/Loader/PageLoader";
import {
  formatBackendDate,
  formatDateToYMD,
} from "./../../../Utils/helperFunction";
import { TransactionDatePicker } from "./../../../Components/DatePicker";
import DeactivationModal from "./../../../Components/Model/Deactivation";
import { useNavigate } from "react-router-dom";

function BasicDetails() {
  const [open, setOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [editingPersonal, setEditingPersonal] = useState(false);
  const [editingAddress, setEditingAddress] = useState(false);
  const { useAccountData, updatePersonalDetails, AddressDetails } =
    useSettings();
  const { handleFieldBlur, handleFieldChange, errors, formData, setFormData } =
    useAuth();

  const user = JSON.parse(getSession("userId"));

  const { data: AccountData, isLoading: accountIsLoading } = useAccountData(
    user?.userId
  );

  useEffect(() => {
    if (AccountData?.data) {
      setFormData({
        firstName: AccountData.data.firstName || "",
        middleName: AccountData.data.middleName || "",
        lastName: AccountData.data.lastName || "",
        pan: AccountData.data.panNumber || "",
        mobileNumber: AccountData.data.mobile?.replace(/^\+91\s*/, "") || "",
        email: AccountData.data.email || "",
        dateOfBirth: AccountData.data.dateOfBirth || "",
        nationality: AccountData.data.nationality || "",
        address: AccountData.data.address || "",
        postcode: AccountData.data.postcode || "",
        city: AccountData.data.city || "",
        state: AccountData.data.state || "",
      });
    }
  }, [AccountData]);

  const renderField = (label, name, isEditing) => {
    if (accountIsLoading) {
      return (
        <div>
          <label className="block font-geomanistRegular font-[400] text-[14px] leading-[20px] text-greyish mb-1">
            {label}
          </label>
          <div className="h-8 bg-gray-200 animate-pulse rounded"></div>
        </div>
      );
    }

    return (
      <div>
        <label className="block font-geomanistRegular font-[400] text-[14px] leading-[20px] text-greyish mb-1">
          {label}
        </label>
        {isEditing ? (
          name !== "dateOfBirth" ? (
            <div>
              <Input
                type={name === "mobileNumber" ? "number" : "text"}
                name={name}
                key={name}
                value={
                  name === "mobileNumber"
                    ? parseInt(formData[name])
                    : formData[name] || ""
                }
                onBlur={(e) => {
                  if (
                    !(
                      AccountData?.data?.status === "APPROVED" &&
                      (name === "firstName" ||
                        name === "middleName" ||
                        name === "lastName" ||
                        name === "dateOfBirth" ||
                        name === "pan")
                    )
                  ) {
                    handleFieldBlur(e);
                  }
                }}
                onChange={(e) => {
                  if (
                    !(
                      AccountData?.data?.status === "APPROVED" &&
                      (name === "firstName" ||
                        name === "middleName" ||
                        name === "lastName" ||
                        name === "dateOfBirth" ||
                        name === "pan")
                    )
                  ) {
                    handleFieldChange(e);
                  }
                }}
                disabled={
                  (AccountData?.data?.status === "APPROVED" &&
                    (name === "firstName" ||
                      name === "middleName" ||
                      name === "lastName" ||
                      name === "dateOfBirth" ||
                      name === "pan")) ||
                  name === "nationality"
                }
                className={`w-full  text-blackShade !font-geomanistBold font-[12px] xl:font-[16px] px-2 xl:px-3 py-1 xl:py-2 ${
                  errors[name] ? "border-red-500" : ""
                } `}
              />
              {errors[name] && (
                <p className="text-failed  font-geomanistRegular text-[12px] mt-1 ml-2">
                  {errors[name]}
                </p>
              )}
            </div>
          ) : (
            <div>
              <TransactionDatePicker
                value={formatBackendDate(formData[name]) || ""}
                className={`w-full text-blackShade !font-geomanistBold font-[16px] px-3 py-2 ${
                  errors[name] ? "border-red-500" : ""
                }`}
                disabled={
                  AccountData?.data?.status === "APPROVED" &&
                  name === "dateOfBirth"
                }
                errorMessage={errors[name]}
                changeDate={(date) => handleFieldChange(date, "dob")}
                onBlur={handleFieldBlur}
              />
            </div>
          )
        ) : (
          <p className="font-geomanistRegular  font-[400] text-[16px] leading-[24px] text-blackShade">
            {name === "dateOfBirth" && formData[name] instanceof Date
              ? formData[name].toLocaleDateString()
              : formData[name] || " "}
          </p>
        )}
      </div>
    );
  };

  const handleEditClick = (section) => {
    // setFormData(AccountData?.data || {});

    if (section === "personal") {
      setEditingPersonal(!editingPersonal);
    } else if (section === "address") {
      setEditingAddress(!editingAddress);
    }
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };

  const handlePersonalSubmit = async (e) => {
    const SignUpData = {
      nationality: "IN",
      countryCode: "IN",
      dateOfBirth: formatDateToYMD(formData?.dob),
      firstName: formData?.firstName,
      middleName: formData?.middleName,
      lastName: formData?.lastName,
      mobile: `+91${formData?.mobileNumber}`,
      pan: formData?.pan,
    };
    e.preventDefault();
    updatePersonalDetails(SignUpData);
    setEditingPersonal(false);
  };

  const handleAddressSubmit = async (e) => {
    e.preventDefault();
    const AddressData = {
      address: formData?.address,
      postcode: formData?.postcode,
      state: formData?.state,
      city: formData?.city,
    };
    AddressDetails(AddressData);
    setEditingAddress(false);
  };
  const navigate = useNavigate();

  return (
    <>
      {accountIsLoading ? (
        <div className="mt-[40px] mb-[40px] w-[100dvh] h-60 ">
          <Loader className=" flex items-center h-36" />
        </div>
      ) : (
        <form onSubmit={handlePersonalSubmit}>
          <div className="mt-[40px] mb-[40px] overflow-scroll">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-blackShade font-[400] font-geomanistBold text-[20px] leading-[28px]">
                Personal Details
              </h2>
              {/* <button
                type="button"
                className="flex items-center gap-2 bg-[#EFEFF1] text-blackShade py-1 px-2 rounded-md"
                onClick={() => handleEditClick("personal")}
              >
                {!editingPersonal ? (
                  <PencilIcon size={16} />
                ) : (
                  <X size={16} className="text-red-500" />
                )}
                <span className="font-geomanistBold text-[14px] leading-[20px]">
                  {editingPersonal ? "Cancel" : "Edit"}
                </span>
              </button> */}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {renderField("First Name", "firstName", editingPersonal)}
              {renderField("Middle Name", "middleName", editingPersonal)}
              {renderField("Last Name", "lastName", editingPersonal)}
              {renderField("PAN Number", "pan", editingPersonal)}
              {renderField("Contact Number", "mobileNumber", editingPersonal)}
              {renderField("Email Address", "email", editingPersonal)}
              {renderField("Date of Birth", "dateOfBirth", editingPersonal)}
            </div>

            {editingPersonal && (
              <div className="mt-6 flex justify-end">
                <button
                  type="submit"
                  className="bg-[#0061D3] text-white px-4 py-2 rounded font-geomanistBold text-[14px] leading-[20px]"
                >
                  Save Changes
                </button>
              </div>
            )}
          </div>
        </form>
      )}
      {accountIsLoading ? (
        <div className="mt-[40px] mb-[40px] w-[100dvh]  border-t">
          <Loader className="h-60" />
        </div>
      ) : (
        <form onSubmit={handleAddressSubmit}>
          <div className="pt-[40px] mb-[40px] border-t">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-blackShade font-[400] font-geomanistBold text-[20px] leading-[28px]">
                Address
              </h2>
              {/* <button
                type="button"
                className="flex items-center gap-2 bg-[#EFEFF1] text-blackShade py-1 px-2 rounded-md"
                onClick={() => handleEditClick("address")}
              >
                {!editingAddress ? (
                  <PencilIcon size={16} />
                ) : (
                  <X size={16} className="text-red-500" />
                )}
                <span className="font-geomanistBold text-[14px] leading-[20px]">
                  {editingAddress ? "Cancel" : "Edit"}
                </span>
              </button> */}
            </div>

            <div className="grid grid-cols-1  sm:grid-cols-2 md:grid-cols-3 gap-6">
              {renderField(
                "Country of Residence",
                "nationality",
                editingAddress
              )}
              {renderField("Address Line 1", "address", editingAddress)}
              {renderField("Pin code", "postcode", editingAddress)}
              {renderField("City", "city", editingAddress)}
              {renderField("State", "state", editingAddress)}
            </div>

            {editingAddress && (
              <div className="mt-6 flex justify-end">
                <button
                  type="submit"
                  className="bg-[#0061D3] text-white px-4 py-2 rounded font-geomanistBold text-[14px] leading-[20px]"
                >
                  Save Changes
                </button>
              </div>
            )}
          </div>
        </form>
      )}

      <div className="pt-[40px] mb-[40px] border-t">
        <button
          className="w-full flex items-center justify-between pb-[24px] text-red-500"
          onClick={toggleAccordion}
        >
          <span className="font-geomanistBold font-[400] text-[20px] leading-[28px] text-[#FA274A]">
            Account Closure
          </span>
          {isOpen ? <ChevronUpIcon size={20} /> : <ChevronDownIcon size={20} />}
        </button>

        {isOpen && (
          <div>
            <p className="font-geomanistRegular font-[400] text-[14px] leading-[20px] text-greyish mb-4">
              This is a permanent and irreversible action. You can reach out
              <br /> to our support team to close your account.
            </p>
            <button
              className="bg-[#0061D3] text-white px-3 py-2 text-[14px] leading-[20px] rounded"
              // onClick={() => setOpen(true)}
              onClick={() => {
                navigate("/contact");
              }}
            >
              Contact Support
            </button>
          </div>
        )}
      </div>

      <DeactivationModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}

export default BasicDetails;
